import { useEffect, useState } from 'react';
import { useBookingApi } from './useBookingActions';
import { useApartmentData } from './useApartments';

export const useBookings = () => {
  const [userGroup, setUserGroup] = useState(null);
  const [userId, setUserId] = useState(null);
  
  const {
    bookings,
    fetchGuestBookings,
    fetchOwnerBookings,
    deleteBooking,
    createOrUpdateBooking,
    error,
  } = useBookingApi();

  const {
    apartments,
    guests,
    fetchApartmentsForGuest,
    fetchOwnerApartments,
  } = useApartmentData();

  useEffect(() => {
    const initializeUserData = () => {
      const storedUserId = localStorage.getItem("user_id");
      const rawGroups = localStorage.getItem("groups");
      let storedGroups = [];

      if (rawGroups) {
        try {
          const parsed = JSON.parse(rawGroups);
          storedGroups = Array.isArray(parsed) ? parsed : [parsed];
        } catch {
          storedGroups = [rawGroups];
        }
      }

      if (storedUserId) {
        setUserId(parseInt(storedUserId, 10));
      }

      const isGuest = storedGroups.some(group => String(group).trim() === "Guests");
      const isOwner = storedGroups.some(group => String(group).trim() === "Owners");

      if (isGuest) {
        setUserGroup("Guests");
        fetchGuestBookings(storedUserId);
        fetchApartmentsForGuest();
      } else if (isOwner) {
        setUserGroup("Owners");
        fetchOwnerBookings(storedUserId);
        fetchOwnerApartments(storedUserId);
      }
    };

    initializeUserData();
  // Intentionally runs once on mount — fetch functions are stable and
  // re-running on every render would cause duplicate API calls.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    userGroup,
    userId,
    bookings,
    apartments,
    guests,
    error,
    deleteBooking,
    createOrUpdateBooking,
    fetchGuestBookings,  // Add these if needed
    fetchOwnerBookings   // Add these if needed
  };
};